import React from "react";
import { useDispatch } from "react-redux";
import { Route, HashRouter as Router, Routes } from "react-router-dom";
import { TabBottom } from "../Layout";
import DataDiri from "../Pages/Auth/dataDiri";
import Login from "../Pages/Auth/Login";
import KodeOTP from "../Pages/Auth/Otp";
import KodeOTPRegister from "../Pages/Auth/OtpRegister";
import Register from "../Pages/Auth/Register";
import Bill from "../Pages/Bill/Bill";
import BillCash from "../Pages/Bill/BillCash";
import BillCashLess from "../Pages/Bill/BillCashLess";
import { CallWaiters } from "../Pages/CallWaiters";
import DetailOrder from "../Pages/DetailOrder/detailorder";
import LacakPesanan from "../Pages/LacakPesanan/LacakPesanan";
import ListLacakPesanan from "../Pages/LacakPesanan/ListLacakPesanan";
import MetodePembayaran from "../Pages/MetodePembayaran/MetodePembayaran";
import Order from "../Pages/Order/Order";
import PaymentSucces from "../Pages/PaymentSucces/paymentsucces";
import Barcode from "../Pages/QRIS/Barcode";
import Nobu from "../Pages/QRIS/Nobu";
import SearchAlamat from "../Pages/SearchAlamat/SearchAlamat";
import TransactionProcessed from "../Pages/TransactionProcessed/TransactionProcessed";
import TransactionProcessed2 from "../Pages/TransactionProcessed/TransactionProcessed2";
import { setKeranjang, setOrder } from "../redux/actions/prepareActions";
import { get_CoaXendit } from "../redux/actions/xenditActions";
import api from "../request";
import { initEncryptionKey, decrypt, initDecryptionKey} from "../utils/enkripsi";
import { showLog } from "../utils/log";

function TabBottoms(params) {
  showLog("Apps Masuk TabBottoms");
  return (
    <TabBottom>
      <Route exact path={"/"} element={<Order />} />
      <Route path={"/lacak-pesanan"} element={<LacakPesanan />} />
      <Route path={"/call-waiters"} element={<CallWaiters />} />
    </TabBottom>
  );
}

function Apps() {
  showLog("Apps Masuk Apps");
  // sessionStorage.clear();
  // localStorage.clear();
  const dispatch = useDispatch();
  const [isReady, setIsReady] = React.useState(false);

  function getUrlVars() {
    showLog("Apps Masuk getUrlVars");
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  }

  async function name(params) {
    showLog("Apps Masuk name");
    const s = getUrlVars();
    const branchQueryString = decrypt(s.params);
    let users = {};
    if (branchQueryString) {
      localStorage.setItem("type", branchQueryString.type);
      localStorage.setItem(
        "userServer",
        JSON.stringify(branchQueryString.clientID)
      );
      users.clientID = branchQueryString.clientID;
      users.branch_id = branchQueryString.branchID;
      const res = await api.apiPrepare.getPos({
        branches: [branchQueryString.branchID],
      });
      let items = res.data[0];
      let getCurrentLoginData = {};
      getCurrentLoginData.branchID = items.id;
      if (branchQueryString.detailDataID) {
        getCurrentLoginData.detailData = branchQueryString.detailDataID;
      }
      getCurrentLoginData.branchName = items.name;
      getCurrentLoginData.branchAddress = items.address;
      getCurrentLoginData.branchTel = items.mobile;
      getCurrentLoginData.picpath = items.picpath;
      localStorage.setItem(
        "dataBranch",
        JSON.stringify(Object.assign(getCurrentLoginData, items))
      );
      const local_charges = await api.apiPrepare.getCharge();
      localStorage.setItem("localCharges", JSON.stringify(local_charges.data));
      // setDataBranch(Object.assign(getCurrentLoginData, items))
      if (branchQueryString.type == "tableQR") {
        users.detailData = branchQueryString.detailDataID;
      }
      // localStorage.setItem("userServer", JSON.stringify(branchQueryString.clientID))
    }
    dispatch(setKeranjang());
    dispatch(setOrder());
    dispatch(get_CoaXendit());
  }

  React.useEffect(() => {
    showLog("Apps Masuk useEffect 1");
    async function initApp() {
      await initEncryptionKey();
      await initDecryptionKey();
      name();
      setIsReady(true);
    }

    initApp();

    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };
  }, []);

  if (!isReady) {
    return null;
  }

  return (
    <Router>
      <Routes>
        {/* <Route path='/home' element={<TabBottoms/>}/> */}
        {/* <Route path='/tableqr/home' component={TabBottom}/> */}
        <Route path="/order" element={<Order />} />
        <Route path="/lacak-pesanan" element={<LacakPesanan />} />
        <Route path="/call-waiters" element={<CallWaiters />} />
        <Route path="/login" element={<Login />} />
        <Route path="/data-diri" element={<DataDiri />} />
        <Route path="/kode-otp" element={<KodeOTP />} />
        <Route path="/kode-otp-register" element={<KodeOTPRegister />} />
        <Route path="/register" element={<Register />} />
        <Route path="/edit-profile" element={<editProfile />} />
        <Route path="/detail-order" element={<DetailOrder />} />
        <Route path="/search-alamat" element={<SearchAlamat />} />
        <Route path="/metode-pembayaran/:id" element={<MetodePembayaran />} />
        <Route path="/list-lacak-pesanan" element={<ListLacakPesanan />} />
        <Route path="/metode-pembayaran-qris/:id" element={<Barcode />} />
        <Route path="/metode-pembayaran-nobu/:id" element={<Nobu />} />
        <Route path="/transaksi-proses" element={<TransactionProcessed />} />
        <Route path="/transaksi-proses2" element={<TransactionProcessed2 />} />
        <Route path="/" element={<Order />} />
        <Route path="/bill" element={<Bill />} />
        <Route path="/bill-cash" element={<BillCash />} />
        <Route path="/bill-cashless" element={<BillCashLess />} />
        <Route path="/payment-succes" element={<PaymentSucces />} />
      </Routes>
    </Router>
  );
}

export default Apps;
